import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { searchParamsNames } from 'constants/searchParamsNames';

/** Хук для получения функции редиректа */
export function useRedirectTo() {
    const navigate = useNavigate();

    return useCallback(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const redirectTo = searchParams.get(searchParamsNames.redirectTo) ?? '';

        navigate(redirectTo);
    }, []);
}
